(() => {
  const stories = document.querySelectorAll('[data-az-origin-story="20260710-editorial"]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  stories.forEach((story) => {
    if (!reducedMotion && 'IntersectionObserver' in window) {
      story.classList.add('az-origin-story--enhanced');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

      story.querySelectorAll('[data-az-reveal]').forEach((element) => observer.observe(element));
    }
  });
})();
